import AlertApp from './views/AlertApp.svelte';
import AdminApp from './views/AdminApp.svelte';
import HomeApp from './views/HomeApp.svelte';
import Login from './views/Login.svelte';
import Register from './views/Register.svelte';
import PasswordReset from './views/PasswordReset.svelte';
import { auth } from './firebase/config.js';
import { wrap } from 'svelte-spa-router';
import { user } from './store.js';
import { get } from 'svelte/store';
import { Role } from './constants.js';

const routes = {
  '/': HomeApp,
  '/register': Register,
  '/app': wrap(
    AlertApp,
    (detail) => isAdmin() || isUser()
  ),
  '/app/*': wrap(
    AlertApp,
    (detail) => isAdmin() || isUser()
  ),
  '/admin': wrap(
    AdminApp,
    (detail) => isAdmin()
  ),
  '/admin/*': wrap(
    AdminApp,
    (detail) => isAdmin()
  ),
  '/login/:email/:password': Login,
  '/login': Login,
  '/reset': PasswordReset,
  '*': HomeApp
};

const isAdmin = () => auth.currentUser && get(user).role === Role.ADMIN;

const isUser = () => auth.currentUser && get(user).role === Role.USER;

export default routes;